export * from './Slider';
export type { SliderProps } from './Slider';
